export default {
    primary: {
        dark: "5a7f29", //Redoc theme cannot process hsl values
        base: "#88c13e",
        light: "#b5d888"
    },
    secondary: {
        dark: "#22445d", //Redoc theme cannot process hsl values
        base: "#005ca3",
        light: "#99bfdb",
        accent: "#0079ad"
    },
    neutral: {
        dark: "hsl(210, 17%, 80%)",
        base: "hsl(210, 16%, 89%)",
        light: "hsl(210, 22%, 96%)",
        lighter: "hsl(210, 20%, 98%)"
    },
    ink: {
        base: "#263540",
        light: "#4d6980",
        lighter: "#94a8b8"
    },
    warning: {
        text: "hsl(360, 60%, 34%)",
        base: "hsl(360, 60%, 50%)",
        light: "hsl(360, 56%, 85%)",
        lighter: "hsl(14, 73%, 94%)",
    },
    success: {
        text: "hsl(109, 12%, 28%)",
        base: "hsl(110, 51%, 48%)",
        light: "hsl(110, 49%, 80%)",
        lighter: "hsl(107, 39%, 91%)",
    },
    attention: {
        text: "hsl(48, 30%, 27%)",
        base: "hsl(48, 100%, 50%)",
        light: "hsl(48, 100%, 80%)",
        lighter: "hsl(46, 89%, 90%)",
    },
    black: "#000000",
    white: "#ffffff",
    whites: {
        90: "rgba(255,255,255,0.9)",
    },
}